var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.field.tooltipIcon)?_c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_c('v-icon',_vm._g(_vm._b({staticClass:"tooltip",attrs:{"medium":""}},'v-icon',attrs,false),on),[_vm._v("mdi-information-outline")])]}}],null,false,3589227261)},[_c('span',[_vm._v(_vm._s(_vm.field.tooltip))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }